const drinks = [
  {
    id: 1,
    name: "Fries",
    
    price: "£0.99"
  },
  {
    id: 2,
    name: "Curley Fries",
    
    price: "£0.99"
  },
  {
    id: 3,
    name: "Nuggets (6 pcs) with Chips",
    
    price: "£3.99"
  },
  {
    id: 4,
    name: "Fish Fingers (3 pcs) with Chips",
    
    price: "£3.99"
  },
  {
    id: 5,
    name: "Cheese Dippers with Chips",
    
    price: "£2.99"
  },
  {
    id: 6,
    name: "Paneer Wrap - Small",
    description: "Indian Wrap with a filling of marinated and pan-fried paneer, plenty of vegetables and Tomato chutney and Coriander and Mint chutney",
    price: "£2.49"
  },
  {
    id: 7,
    name: "Chicken Wrap - Small",
    description: "Indian Wrap with a filling of marinated and pan-fried chicken strips, salad vegetables and Tomato chutney and Coriander and Mint chutney",
    price: "£2.89"
  },
  {
    id: 8,
    name: "Egg Fried Rice",
    
    price: "£2.49"
  },
  {
    id: 9,
    name: "Omelette Sandwich (x2)",
    description: "2 Pcs",
    price: "£1.99"
  }
];

export default drinks